import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import {
  DISPATCH_PLANNING_AGAINST_PLLANING_ID,
  CREATE_DISPATCH_PLANNING,
  WABA_DISPATCH_TRIGGER
} from '../../config/api';

import PlanningDetails from './cards/PlanningDetails';
import DispatchForm from './cards/DispatchForm';

function DispatchPlanning() {
  const [params] = useSearchParams();
  const user_id = params.get('user_id');
  const org_id = params.get('org_id');
  const planning_id = params.get('planning_id');

  const [planningData, setPlanningData] = useState(null);
  const [planningLoading, setPlanningLoading] = useState(false);
  const [planningError, setPlanningError] = useState('');

  const [form, setForm] = useState({
    dispatch_date: '',
    dispatch_qty: '',
    qty: '',
    vehicle_no: '',
    remark: '',
    driver_name: '',
    driver_mobile: '',
    transporter_id: '',
    sub_transporter_id: '',
    diesel_ltr: '',
    cash_amount: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // ✅ helper: normalize API response into an object
  const normalizePlanning = (raw) => {
    if (!raw) return null;
    if (Array.isArray(raw)) return raw[0] || null;
    if (raw.data) return raw.data;
    if (raw.result) return raw.result;
    return raw; // direct object
  };

  useEffect(() => {
    const fetchPlanning = async () => {
      if (!planning_id) return;

      setPlanningLoading(true);
      setPlanningError('');

      try {
        const res = await fetch(DISPATCH_PLANNING_AGAINST_PLLANING_ID, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ planning_id, user_id, org_id })
        });

        const raw = await res.json();
        const data = normalizePlanning(raw);

        console.log("PLANNING RAW =>", raw);
        console.log("PLANNING NORMALIZED =>", data);

        setPlanningData(data);

        // ✅ OPTIONAL: auto-fill dispatch qty from planning qty
        if (data?.planned_qty && !form.dispatch_qty) {
          setForm((prev) => ({
            ...prev,
            dispatch_qty: String(data.planned_qty),
            qty: String(data.planned_qty)
          }));
        }
      } catch (err) {
        console.error('Error fetching planning:', err);
        setPlanningError('Failed to load planning details.');
        setPlanningData(null);
      } finally {
        setPlanningLoading(false);
      }
    };

    fetchPlanning();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planning_id, user_id, org_id]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const res = await fetch(CREATE_DISPATCH_PLANNING, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          user_id,
          org_id,
          planning_id
        })
      });

      const result = await res.json();

      if (res.ok) {
        setMessage('Dispatch created successfully');

        // ✅ reset only dispatch form (not planningData)
        setForm({
          dispatch_date: '',
          dispatch_qty: '',
          qty: '',
          vehicle_no: '',
          remark: '',
          driver_name: '',
          driver_mobile: '',
          transporter_id: '',
          sub_transporter_id: '',
          diesel_ltr: '',
          cash_amount: ''
        });

        // 🔔 Trigger WABA Dispatch Message
        try {
          if (result?.dispatch_id) {
            await fetch(WABA_DISPATCH_TRIGGER, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ dispatch_id: result.dispatch_id })
            });
          }
        } catch (err) {
          console.error('Failed to send WABA dispatch message:', err);
        }
      } else {
        setMessage(result?.error || 'Failed to create dispatch');
      }
    } catch (err) {
      console.error(err);
      setMessage('Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4 className="mb-4">Dispatch Planning</h4>

        {/* ✅ Planning Details Block */}
        {planningLoading && <p>Loading planning details...</p>}

        {!planningLoading && planningError && (
          <div className="alert alert-danger">{planningError}</div>
        )}

        {!planningLoading && planningData && (
          <PlanningDetails planningData={planningData} />
        )}

        {/* ✅ Dispatch Form */}
        <DispatchForm
          form={form}
          loading={loading}
          message={message}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      </div>
    </>
  );
}

export default DispatchPlanning;
